import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const {
  colors: { ui },
} = constants;

const red = ui.red[500];
const white = ui.white[600];
const blue = ui.core[600];

export const wrapperCss: CSSObject = {
  marginBottom: "20px",
  overflow: "visible",
  backgroundColor: white,
};

export const fieldsetCss: CSSObject = {
  margin: 0,
  padding: 0,
  border: "none",
};

export const optionsWrapperCss: CSSObject = {
  display: "flex",
  gap: "18px",
  marginBottom: "8px",
};

export const optionCss: CSSObject = {
  width: "auto",
};

export const asteriskCss = (hasError: boolean): CSSObject => ({
  color: hasError ? red : blue,
});

export const errorMessageCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  color: red,
};

export const errorMessageIconCss: CSSObject = {
  marginRight: "8px",
  path: {
    stroke: red,
  },
};

export const errorMessageWrapper: CSSObject = {
  marginBottom: "12px",
};

export const errorBorderCss: CSSObject = {
  border: `1px ${red} solid`,
};
